import { render, staticRenderFns } from "./XbPlayer.vue?vue&type=template&id=01f1e930&scoped=true&"
import script from "./XbPlayer.vue?vue&type=script&lang=js&"
export * from "./XbPlayer.vue?vue&type=script&lang=js&"
import style0 from "./XbPlayer.vue?vue&type=style&index=0&id=01f1e930&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f1e930",
  null
  
)

export default component.exports